const linkLists = [
    { name: '2º via de carteirinha', path: '/dados_beneficiario/selecionar_acao' },
    { name: 'Trocar o plano', path: '/movimentacao_cadastral/selecionar_trocar_plano' },
    { name: 'Adicionar beneficiário', path: '/movimentacao_cadastral/adicionar_beneficiario' },
    { name: 'Consultar faturas', path: '/faturamento/consultar_faturas', useToSpecificContract: true },
    { name: 'Movimentações pendentes', path: '/movimentacao_cadastral/movimentacoes_pendentes' },
];

export default linkLists;
